export default __webpack_public_path__ + "static/sabanci-1d8912002b16cd5c3413d823cb08a204.png";